<template>
  <!-- Feature Section start -->
  <section class="usecase">
    <div class="feature-decor">
      <div class="feature-circle1">
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="column col-md-11 col-sm-12">
          <h1 class="text-white"><slot name="use_case_title"></slot></h1>
            <div class="use-group top">
                <div class="use-container col-md-4 col-sm-12 col-xs-12">
                  <router-link :to="getUseCaseUrl('addsubtitleslang')" class="display-url-link">   
                  <div class="use-group-header">
                       <!-- <img alt="youtube background" :src='"@/assets/images/landing/test1.png"'> -->
                       <img alt="youtube background" :src='"@/assets/images/landing/icon_01.webp"'>
                        <h2 class="use-group-title"><slot name="youtubers"></slot></h2>
                        <h3><slot name="youtubers_question"></slot></h3>
                         <h4 class="blockdesc">
                     
                          <slot name="learnmore"></slot> →

                          <!-- <slot name="youtubers"></slot>  -->
                           <!-- <slot name="youtubers_desc"></slot> -->
                        </h4>
                    </div>
                  </router-link>
                </div>
                <div class="use-container col-md-4 col-sm-12 col-xs-12">
                  <router-link :to="getUseCaseUrl('aianalysislang')" class="display-url-link">   
                     <div class="use-group-header">
                       <!-- <img alt="journalist background" :src='"@/assets/images/landing/test2.png"'> -->
                       <img alt="youtube background" :src='"@/assets/images/landing/icon_11.webp"'>
                        <h2 class="use-group-title"><slot name="journalists"></slot></h2>
                        <h3><slot name="journalists_question"></slot></h3>
                         <h4 class="blockdesc">
                          <slot name="learnmore"></slot> →
                          <!-- <slot name="journalists"></slot> → -->
                           <!-- <slot name="journalists_desc"></slot> -->
                        </h4>
                    </div>
                  </router-link>
                </div>

                <div class="use-container col-md-4 col-sm-12 col-xs-12">
                  <router-link :to="getUseCaseUrl('translatelang')" class="display-url-link">   
                     <div class="use-group-header">
                       <!-- <img alt="globe background" :src='"@/assets/images/landing/test1.png"'> -->
                       <img alt="youtube background" :src='"@/assets/images/landing/icon_03.webp"'>
                        <h2 class="use-group-title"><slot name="translators"></slot></h2>
                        <h3><slot name="translators_question"></slot></h3>
                         <h4 class="blockdesc">
                          <slot name="learnmore"></slot> →
                           <!-- <slot name="translators_desc"></slot> -->
                        </h4>
                    </div>
                  </router-link>
                </div>
                <!-- <div class="use-container col-md-3 col-sm-12 col-xs-12">
                     <div class="use-group-header">
                       <img alt="youtube background" :src='"@/assets/images/landing/test4.png"'>
                        <h2 class="use-group-title"><slot name="speaker"></slot></h2>
                        <h3><slot name="speaker_question"></slot></h3>
                         <h4 class="blockdesc">
                          <slot name="speaker"></slot> →
                        </h4>
                    </div>
                </div> -->
            </div>
            
        </div>
      </div>


      <div class="row">
        <div class="column col-md-11 col-sm-12">
            <div class="use-group">
              <div class="use-container col-md-4 col-sm-12 col-xs-12">
                <router-link :to="getUseCaseUrl('speakerlang')" class="display-url-link">   
                     <div class="use-group-header">
                       <img alt="youtube background" :src='"@/assets/images/landing/icon_04.webp"'>
                        <h2 class="use-group-title"><slot name="speaker"></slot></h2>
                        <h3><slot name="speaker_question"></slot></h3>
                         <h4 class="blockdesc">
                          <slot name="learnmore"></slot> →
                        </h4>
                    </div>
                  </router-link>
                </div>
                <!-- <div class="use-container col-md-3 col-sm-12 col-xs-12">
                     <div class="use-group-header">
                       <img alt="youtube background" :src='"@/assets/images/landing/test1.png"'>
                        <h2 class="use-group-title"><slot name="timealign"></slot></h2>
                        <h3><slot name="timealign_question"></slot></h3>
                         <h4 class="blockdesc">
                          <slot name="timealign"></slot> →
                        </h4>
                    </div>
                </div> -->

                <!-- <div class="use-container col-md-4 col-sm-12 col-xs-12" @click="onUseCaseClicked('audiotovideolang')">
                     <div class="use-group-header">
                       <img alt="youtube background" :src='"@/assets/images/landing/icon_06.webp"'>
                        <h2 class="use-group-title"><slot name="audiotomp4"></slot></h2>
                        <h3><slot name="audiotomp4_question"></slot></h3>
                         <h4 class="blockdesc">
                          <slot name="learnmore"></slot> →
                        </h4>
                    </div>
                </div> -->

                <div class="use-container col-md-4 col-sm-12 col-xs-12">
                  <router-link :to="getUseCaseUrl('transcriptstosubtitleslang')" class="display-url-link">   
                     <div class="use-group-header">
                       <img alt="youtube background" :src='"@/assets/images/landing/test1.png"'>
                        <h2 class="use-group-title"><slot name="importsrt"></slot></h2>
                        <h3><slot name="importsrt_question"></slot></h3>
                         <h4 class="blockdesc">
                          <slot name="learnmore"></slot> →
                        </h4>
                    </div>
                  </router-link>
                </div>
                <div class="use-container col-md-4 col-sm-12 col-xs-12">
                  <router-link :to="getUseCaseUrl('collaboratelang')" class="display-url-link">   
                     <div class="use-group-header">
                       <img alt="youtube background" :src='"@/assets/images/landing/icon_08.webp"'>
                        <h2 class="use-group-title"><slot name="share"></slot></h2>
                        <h3><slot name="share_question"></slot></h3>
                         <h4 class="blockdesc">
                          <slot name="learnmore"></slot> →
                           <!-- <slot name="translators_desc"></slot> -->
                        </h4>
                    </div>
                  </router-link>
                </div>
            </div>
            
        </div>
      </div>

    </div>
  </section>
  <!-- Feature Section End -->
</template>

<script>
import textHelper from "@/utils/textManager";
export default {
  name: "UseCaseSection",
  methods:{
    onUseCaseClicked(name){
      
      this.$router.push({name:name, params: { language: textHelper.getDisplayLanguage() } })
    },
    getUseCaseUrl(name){
      if(!textHelper.getDisplayLanguage()){
        return {name:name.replace('lang','') };
      }
      else{
        return {name:name, params: { language: textHelper.getDisplayLanguage() } };
      }
    }
  }
};
</script>
<style scope>

.v-application h4.blockdesc {
    padding: 5px;
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    color: #02b2fa;
}

/* .v-application  h4.blockdesc {
     padding: 5px;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
    color:#00d1b2;
} */

.use-group {
  max-width: 100%;
}
.use-group.top {
  padding-top: 50px;
}

.use-group-header {
  position:relative;
  width:100%;
}
.use-group-header img{
  display:block;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  top:-90px;
  opacity: 0.7;
  /* width:20%;
  height:auto; */
  width:80px;
  height:80px;
  z-index:-1;
  filter: hue-rotate(-26deg);
}

.use-group-header h2,
.use-group-header h3,
.use-group-header .blockdesc{
    text-align: center;
}


.use-group-header h2{
  margin-bottom: 0px;
  font-size:20px;
  letter-spacing: 0px;
  text-transform: none;
}
.use-group-header h3{
  margin-top: 0px;
  color:#0aa795;
  min-height:56px;
  text-transform: none;
  letter-spacing: 0px;
}

/* .use-group-header h3{
  color:#00d1b2;
} */

.use-container{
    padding:0px 10px;
    display: inline-flex;
    cursor: pointer;
}

section.usecase {
    margin-top: 0px!important;
}


.usecase .column {
  margin: 0 auto;
}

.about-circle1 img{
  filter: brightness(0.25); 
}

@media (max-width: 992px){
.usecase h1 {
    line-height: 57px;
    margin-top:0px;
}

section.usecase {
    padding-bottom: 50px;
    padding-top: 0px;
    margin-top: 0px!important;
}

.use-container:not(:first-child) {
    position: relative;
    margin-top: 50px;
}


}
</style>